import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ErrorModalData {
  title: string;
  errors: Array<string>;
}

@Component({
  selector: 'ui-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent implements OnInit {
  public errors: Array<string> = [];
  public title = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ErrorModalData,
    public dialogRef: MatDialogRef<ErrorModalComponent>,
  ) {}

  public ngOnInit(): void {
    this.title = this.data?.title ?? 'Something went wrong!';
    this.errors = this.data?.errors ?? [];
  }

  public closeModal(event: Event): void {
    event.preventDefault();

    this.dialogRef.close();
  }
}
